export enum PaymentMethodProperties {
  Name = 'name',
  PaymentMethodType = 'paymentMethodType',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum PaymentMethodMetaProperties {}
